import { render, staticRenderFns } from "./extEdit.vue?vue&type=template&id=172b6411&scoped=true&"
import script from "./extEdit.vue?vue&type=script&lang=js&"
export * from "./extEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172b6411",
  null
  
)

export default component.exports